<template>
    <div id="loader-page" class="loading-page left-0 d-center ">
        <div class="loader__circle"></div>
    </div>
</template>

<script>


export default {
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
